import { createStyles, makeStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    paymentsHeaderBlock: {
      justifyContent: 'space-between',
      background: 'transparent',
      padding: '24px 40px',
      display: 'flex',
      height: '100px',
      alignItems: 'center',
      [theme.breakpoints.down('lg')]: {
        height: 'auto',
        flexDirection: 'column',
        gap: '20px',
        alignItems: 'baseline'
      },
      [theme.breakpoints.only('sm')]: {
        alignItems: 'flex-start'
      },
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        padding: '18px 20px 18px 20px',
        flexDirection: 'row',
        height: '100px'
      },
      [theme.breakpoints.only('xs')]: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0px',
        height: '125px'
      }
    },
    paymentsHeading: {
      fontSize: '40px',
      fontWeight: 600,
      lineHeight: '1',
      [theme.breakpoints.only('xs')]: {
        fontSize: '32px'
      }
    },
    formLabel: {
      margin: '0px 0px 10px',
      fontSize: '16px',
      fontWeight: 'bold',
      paddingLeft: '16px'
    },
    formBox: {
      background: 'transparent',
      minWidth: '100%',
      height: '110px',
      [theme.breakpoints.down('xs')]: {
        height: '110px'
      },
      '& > * > *': {
        [theme.breakpoints.down('xs')]: {
          minWidth: '240px',
          width: '245px'
        }
      }
    },
    formInnerContainer: {
      display: 'flex',
      flexDirection: 'column',
      background: 'transparent',
      flex: 1,
      minHeight: 0
    },
    venueTaxDetailsOuterBox: {
      flex: 'none',
      background: 'transparent'
    },
    venueTaxDetailsHeaders: {
      lineHeight: '1.13',
      fontSize: '16px',
      fontWeight: 600,
      cursor: 'pointer'
    },
    buttonGroup: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '1rem',
      marginTop: '2rem',
      flex: 'none'
    }
  })
);
